import { InjectionToken } from "@angular/core";

export type FormErrorTypeAssign = string & { max: number; actual: number } & {
	requiredLength: number;
	actualLength: number;
} & { min: number; actual: number } & {
	requiredMask: string;
	actualValue: string;
} & { minInstallment: number; actual: number } & {
	maxInstallment: number;
	actual: number;
};

export interface FormErrorTypes {
	required(fieldName: string): string;
	email(): string;
	pattern(): string;
	maxlength(fieldLength: {
		requiredLength: number;
		actualLength: number;
	}): string;
	minlength(fieldLength: {
		requiredLength: number;
		actualLength: number;
	}): string;
	min(fieldValue: { min: number; actual: number }): string;
	max(fieldValue: { max: number; actual: number }): string;
	requiredTrue(): string;
	passwordStrength(): string;
	passwordDoesNotMatch(): string;
	currencyInvalidFormat(): string;
	integerNumberInvalidFormat(): string;
	invalidComissionValue(): string;
	mask(mask: { requiredMask: string; actualValue: string }): string;
	banksAreEquals(): string;
	minInstallments(fieldValue: {
		minInstallment: number;
		actual: number;
	}): string;
	maxInstallments(fieldValue: {
		maxInstallment: number;
		actual: number;
	}): string;
	emailNotificationEnabledWithoutFieldFilledIn(): string;
	smsAndWhatsappNotificationsEnabledWithoutFieldFilledIn(): string;
	whatsappNotificationEnabledWithoutFieldFilledIn(): string;
	smsNotificationEnabledWithoutFieldFilledIn(): string;
	taxpayerRegistrationAlreadyExists(): string;
}

const defaultErrors: FormErrorTypes = {
	required: (): string => "Esse campo é obrigatório",
	email: (): string => "Insira um e-mail válido!",
	pattern: (): string => "Insira um pattern válido!",
	maxlength: (fieldLength: {
		requiredLength: number;
		actualLength: number;
	}): string => `Tamanho máximo do campo é: ${fieldLength.requiredLength}!`,
	minlength: (fieldLength: {
		requiredLength: number;
		actualLength: number;
	}): string => `Tamanho mínimo do campo é: ${fieldLength.requiredLength}!`,
	min: (fieldValue: { min: number; actual: number }): string =>
		`O valor mínimo permitido para esse campo é: ${fieldValue.min}`,
	max: (fieldValue: { max: number; actual: number }): string =>
		`O valor máximo permitido para esse campo é: ${fieldValue.max}`,
	requiredTrue: (): string => "É necessário aceitar os termos!",
	passwordStrength: (): string =>
		"É necessário uma letra maiúscula, minúscula e um caracter especial",
	passwordDoesNotMatch: (): string => "As senhas não conferem",
	currencyInvalidFormat: (): string =>
		"É necessário inserir um formato de valor válido",
	integerNumberInvalidFormat: (): string =>
		"É necessário inserir um numero válido",
	invalidComissionValue: (): string => "O valor máximo permitido é 999,99",
	mask: (mask: { requiredMask: string; actualValue: string }): string =>
		`Formato necessário: ${mask.requiredMask}`,
	banksAreEquals: (): string => `Os bancos não podem ser iguais`,
	minInstallments: (fieldValue: {
		minInstallment: number;
		actual: number;
	}): string => `O número mínimo de parcelas é ${fieldValue.minInstallment}`,
	maxInstallments: (fieldValue: {
		maxInstallment: number;
		actual: number;
	}): string => `O número máximo de parcelas é ${fieldValue.maxInstallment}`,
	emailNotificationEnabledWithoutFieldFilledIn: (): string =>
		"O campo é obrigatório quando o meio de envio e-mail está ativo. Desmarque o envio pelo meio ou preencha o campo.",
	smsAndWhatsappNotificationsEnabledWithoutFieldFilledIn: (): string =>
		"O campo é obrigatório quando os meios de envio WhatsApp e SMS estão ativos. Desmarque os envios pelos meios ou preencha o campo.",
	whatsappNotificationEnabledWithoutFieldFilledIn: (): string =>
		"O campo é obrigatório quando o meio de envio WhatsApp está ativo. Desmarque o envio pelo meio ou preencha o campo.",
	smsNotificationEnabledWithoutFieldFilledIn: (): string =>
		"O campo é obrigatório quando o meio de envio SMS está ativo. Desmarque o envio pelo meio ou preencha o campo.",
	taxpayerRegistrationAlreadyExists: (): string =>
		"Este CPF/CNPJ já possui um cadastro"
};

export const FORM_ERRORS = new InjectionToken<FormErrorTypes>("FORM_ERRORS", {
	providedIn: "root",
	factory: () => defaultErrors
});
